import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Grid,
  TextField,
  Typography,
  Paper,
} from '@mui/material';

interface Props {
  email: string;
  password: string;
  onChange: (field: string) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const CommonFields: React.FC<Props> = ({
  email,
  password,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Paper elevation={0} className="glass-effect" sx={{ p: 3, borderRadius: 2 }}>
      <Typography 
        variant="h6" 
        className="animated-gradient-text" 
        gutterBottom 
        sx={{ 
          mb: 4,
          fontFamily: 'Poppins, sans-serif'
        }}
      >
        {t('registration.accountInfo')}
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('registration.email')}
            type="email"
            value={email}
            onChange={onChange('email')}
            required
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('registration.password')}
            type="password"
            value={password}
            onChange={onChange('password')}
            required
            variant="outlined"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CommonFields;
